import React, { useState } from 'react';
import { useContractProjectSuggestions } from './useContractProjectSuggestions';
import { SuggestionsPickerBase } from '../SuggestionsPickerBase';

export const ContractProjectsPicker = (props) => {
  const { selected, ...restProps } = props;

  const [query, setQuery] = useState('');

  const [suggested, excluded, suggestionsLoading] =
    useContractProjectSuggestions({
      context: undefined,
      selected,
      query
    });

  return (
    <SuggestionsPickerBase
      {...restProps}
      suggestions={suggested}
      query={query}
      setQuery={setQuery}
      primaryKey="display_name"
      placeholder="Start typing a project name..."
      loading={suggestionsLoading}
      allowAddingOfNewSuggestions={false}
      excludedSuggestions={excluded}
    />
  );

  // return (
  //   <SuggestionsPicker
  //     {...restProps}
  //     allSuggestions={suggested}
  //     excludedSuggestions={excluded}
  //     placeholder="Start typing a project name..."
  //     suggestionsLoading={suggestionsLoading}
  //     showDisabled={true}
  //     excludedReasonText={'Project is archived'}
  //   />
  // );
};
